export default __webpack_public_path__ + "static/media/announcement_2.9421a70e.png";